import { createReducer } from '@reduxjs/toolkit';

import getPermissions from '../../thunks/permissions/getPermissions';

const initialState = {
  loading: false,
  error: null,
  permissions: undefined,
  permissionsObject: undefined
};

const getPermissionsReducer = createReducer(initialState, {
  [getPermissions.pending]: (state) => ({
    ...state,
    loading: true,
    error: null
  }),
  [getPermissions.fulfilled]: (state, { payload: { permissions, permissionsObject } }) => ({
    ...state,
    loading: false,
    permissions,
    permissionsObject
  }),
  [getPermissions.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
    permissions: undefined,
    permissionsObject: undefined,
  }),
});

export default getPermissionsReducer;
